module.exports = __webpack_public_path__ + "img/1.001d6c13.png";